<template>
  <div class="fc-org-select">
    <div class="tags">
      <div class="input-box as-input">
        <el-tag v-for="item in selectedData" :key="item.id" closable class="org-tag" @close="onClose(item)">
          {{ item.label }}
        </el-tag>
        <el-tag type="success" class="org-tag" @click="dialogTableVisible = true">
          + 添加人员
        </el-tag>
      </div>
    </div>
    <el-dialog title="组织机构" :visible.sync="dialogTableVisible" width="40%" :close-on-click-modal="false">
      <div style="text-align:center">
        <tree-transfer v-model="value" :data="list" filterable />
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmSelect">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import TreeTransfer from './tree-transfer'
  export default {
    name: 'OrganizationSelect',
    components: {
      TreeTransfer,
    },
    props: {
      list: {
        type: Array,
        default: () => [],
      },
      model: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        dialogTableVisible: false,
        selectedData: [],
        filterArray: [],
        value: [],
      }
    },
    watch: {
      list: {
        handler(newval) {
          this.filterArray = this.treeToArray(newval)
        },
        deep: true,
        immediate: true,
      },
      model: {
        handler(newval) {
          this.value = newval
          this.selectedData = this.filterPerson()
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      onClose(data) {
        this.selectedData = this.selectedData.filter((item) => item.id !== data.id)
        this.value = this.filterClose(this.selectedData)
        this.$emit('update:model', this.value)
      },
      confirmSelect() {
        this.selectedData = this.filterPerson()
        this.$emit('update:model', this.value)
        this.dialogTableVisible = false
      },
      // 将树转换成数组的形式,传入tree数据，返回array数据
      treeToArray(tree) {
        let arr = []
        const expanded = (datas) => {
          if (datas && datas.length > 0) {
            datas.forEach((e) => {
              arr.push({ id: e.id, label: e.label, flag: e.children ? true : false })
              expanded(e.children)
            })
          }
        }
        expanded(tree)
        return arr
      },
      filterPerson() {
        let personArray = []
        for (let i = 0; i < this.filterArray.length; i++) {
          for (let k = 0; k < this.value.length; k++) {
            if (this.value[k] === this.filterArray[i].id && !this.filterArray[i].flag) {
              personArray.push(this.filterArray[i])
            }
          }
        }
        return personArray
      },
      filterClose(data) {
        let closeArray = []
        for (let i = 0; i < this.selectedData.length; i++) {
          closeArray.push(this.selectedData[i].id)
        }
        return closeArray
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tags {
    .input-box.as-input {
      border: 1px solid #dcdfe6;
      padding-left: 6px;
      font-size: 12px;
      min-height: 32px;
      line-height: 30px;
      border-radius: 4px;
      background: white;
      color: #606266;
      cursor: pointer;
    }
    .org-tag {
      // margin-right: px;
      max-width: 6rem;
      overflow: hidden text-overflow ellipsis position relative padding-right 1rem vertical-align middle;
      // >>> .el-tag__close {
      //   position: absolute;
      //   right: 2px;
      //   top: 50%;
      //   margin-top: -7px;
      // }
    }
  }
</style>
